/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getTekeCustomerTable = params => {
  return axios.post(`${base}/teke/query_customer`, params)
}
export const setPlatformFee = params => {
  return axios.post(`${base}/teke/set_platform_fee`, params)
}
export const deleteTekeCustomer = id => {
  return axios.post(`${base}/teke/delete_customer_` + id)
}
export const getTekeMemberTable = params => {
  return axios.post(`${base}/teke/query_customer_member_` + params.customerid, params)
}
export const createCustomer = params => {
  return axios.post(`${base}/teke/create_customer`, params)
}
export const editTekeCustomer = params => {
  return axios.post(`${base}/teke/edit_customer_` + params.id, params)
}
export const getTekeCustomer = id => {
  return axios.get(`${base}/teke/customers_` + id)
}
export const batchEditPlatformFee = params => {
  return axios.post(`${base}/teke/batch_edit_platform_fee`, params)
}
export const createCustomerMember = params => {
  return axios.post(`${base}/teke/create_pfmaccount`, params)
}
export const editCustomerMember = params => {
  return axios.post(`${base}/teke/edit_pfmaccount_` + params.id, params)
}
export const getTekeCustomerDetail = id => {
  return axios.get(`${base}/teke/customer_detail_` + id)
}
export const getTekeCustomerBalance = id => {
  return axios.get(`${base}/teke/customer_balance_` + id)
}
export const getTekeCustomerRechargeTable = params => {
  return axios.post(`${base}/teke/query_customer_recharge_` + params.customerid, params)
}
export const createCustomeRecharge = params => {
  return axios.post(`${base}/teke/create_customer_recharge_` + params.customerid, params)
}
export const getTekeCustomerBalanceTable = params => {
  return axios.post(`${base}/teke/query_customer_balance_` + params.customerId, params)
}
export const UploadTekeFile = params => {
  return axios.post(`${base}/teke/upload_file`, params)
}
export const getTekeCustomerMember = id => {
  return axios.get(`${base}/teke/customer_member_` + id)
}



// WEBPACK FOOTER //
// ./src/views/teke-customer/tekeCustomer.api.js